module.exports = __webpack_public_path__ + "static/userDashboard-6c83880239ffaef41a54521c5eed4611.png";